import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable()
export class WindowRef {
  get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }
  get nativeWindow(): any {
    return _window();
  }
  get nativeScrollTo(): any {
    return this.nativeWindow.scrollTo;
  }

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
}
